import {useDebugValue} from 'react';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';

import {runErrorStatesOnSearchFormExperiment} from '../../../utils/experiments';

import {
    showDestinationInputFieldError,
} from '../../../utils/destination';

function useComponent() {
    const {
        abacusStore,
        mediaSettings,
        formOptions,
        formSettings,
        destinationOptions,
        latestDestinationValues,
        systemOptions,
    } = useSearchFormContext();

    const showDestinationErrorMessage = runErrorStatesOnSearchFormExperiment({shouldLogExperiment: false}, abacusStore, formSettings, false) && showDestinationInputFieldError(mediaSettings, formOptions, formSettings, destinationOptions, latestDestinationValues, abacusStore, systemOptions);

    const result = {showDestinationErrorMessage};

    useDebugValue(result);

    return result;
}

export {useComponent};